'use client'

import { useState } from 'react'

import { InfoBanner } from '@marketplace-web/info-banner/info-banner-feature'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import EscrowBanner from '../EscrowBanner'

const ConversationBanners = () => {
  const { conversation } = useConversationContext()

  const [isInfoBannerPresent, setIsInfoBannerPresent] = useState<boolean>()

  return (
    <>
      {conversation?.id && (
        <InfoBanner
          screen="message_reply"
          params={{ user_msg_thread_id: conversation.id }}
          onBannerLoad={setIsInfoBannerPresent}
        />
      )}
      {isInfoBannerPresent === false && <EscrowBanner conversation={conversation} />}
    </>
  )
}

export default ConversationBanners
